import {
    GROUP_USERS_REQUESTED,
    GROUP_USERS_RECEIVED,
    GROUP_USERS_ERROR
} from '../actions/groupUsers.js';
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
 *
 * @param {RequestResult} state
 * @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
 * @return {RequestResult}
 */
export const groupUsers = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

    switch (action.type) {
        case GROUP_USERS_REQUESTED:
            return new RequestResult(RequestState.getInstanceLoading(), state.data);
        case GROUP_USERS_RECEIVED:
            return new RequestResult(RequestState.getInstanceDone(), action.groupUsers, action.receivedAt);
        case GROUP_USERS_ERROR:
            return new RequestResult(
                RequestState.getInstanceError(
                    action.errorResponseStatusCode,
                    action.errorResponseMessage ? action.errorResponseMessage : null
                ),
                state.getData()
            );
        default:
            return state
    }
};
